<script lang="ts">
    import PageBuilder from '$lib/components/PageBuilder/PageBuilder.svelte';
    import PageSEO from '$lib/components/PageSEO/PageSEO.svelte';
    import type { TPageLoadResult } from '$src/lib/services/page/load.factory.server';
    import PageProperties from './PageProperties.svelte';
    export let page: TPageLoadResult['pageData'];
    export let debug = false;
</script>

<svelte:head>
    {#await page then { seo: { meta, markets } }}
        <PageSEO {meta} {markets} />
    {/await}
</svelte:head>

<div>
    {#await page then { blockData, cssReferences, scriptReferences, pageProperties }}
        <PageProperties {pageProperties} />
        <PageBuilder {blockData} {cssReferences} {scriptReferences} {debug} />
    {/await}
</div>
